import { render } from "./StudentMark.vue?vue&type=template&id=6c7d9b20&scoped=true"
import script from "./StudentMark.vue?vue&type=script&lang=js"
export * from "./StudentMark.vue?vue&type=script&lang=js"

import "./StudentMark.vue?vue&type=style&index=0&id=6c7d9b20&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-director-production/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7d9b20"]])

export default __exports__